import { Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { AddMemberComponent } from '../add-member/add-member.component';
import { NotificationService } from '../shared/services/notifications.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Roles } from '../../models/commonmodel';
import { ConfirmationMode } from '../shared/share';
import { CustomDateAdapter } from '../shared/pipes/custom-date-adapter';
import { MY_NATIVE_DATE_FORMATS } from '../shared/pipes/date-format';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';

@Component({
  selector: 'app-add-admin-distributor',
  standalone: true,
  imports: [MatFormFieldModule, ReactiveFormsModule, CommonModule, MatInputModule, MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule],
  templateUrl: './add-admin-distributor.component.html',
  styleUrl: './add-admin-distributor.component.scss',
  providers: [
    DatePipe, // optional, useful if you're formatting dates elsewhere
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_NATIVE_DATE_FORMATS }
  ],
  animations: [
    trigger('userCardAnimation', [
      state('unselected', style({
        transform: 'scale(1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        borderColor: 'transparent'
      })),
      state('selected', style({
        transform: 'scale(1.03)',
        borderColor: '#0075C9',
        background: 'linear-gradient(157deg, rgb(0 117 201 / 0%), rgb(102 174 224 / 20%))'
      })),
      transition('unselected <=> selected', [
        animate('250ms ease-in-out')
      ]),
    ])
  ]
})
export class AddAdminDistributorComponent {

  ngOnInit() {

    if (this.editedAdmin) {
      this.insurerForm.patchValue({ tradingName: this.editedAdmin.tradingName })
      this.insurerForm.get('fcaReferenceNumber')?.disable();
      this.insurerForm.get('tradingName')?.disable();
      this.preFillForm(this.editedAdmin);
    } else {
      this.insurerForm.get('firstName')?.enable();
      this.insurerForm.get('lastName')?.enable();
    }
    this.getAdminInsurer();
  }


  onFileDropped(event: Event) {
    event.preventDefault();
    const dragEvent = event as DragEvent;
    const files = dragEvent.dataTransfer ? dragEvent.dataTransfer.files : null;
    console.log(files);
    if (files && files.length > 0) {
      // this.handleFiles(files);
    }
  }

  preFillForm(data: any): void {
    if (data && this.insurerForm) {
      this.popupTitle = 'Edit Admin Distributor';
      this.popupSubtitle = 'Please provide the information below to edit admin Distributor.';
      console.log(data)
      this.insurerForm.patchValue({
        fcaReferenceNumber: this.data.fcaReferenceNumber,
        tradingName: this.data.tradingName,
        role: 'ADMIN_DISTRIBUTOR',
        address: this.data.address,
        websiteUrl: this.data.websiteUrl,
        contactName: this.insurerForm.get('contactPerson')?.value,
        contactEmail: this.data.email,
        contactPhone: this.data.contactPhone,
        //  data.dateOfBirth ? this.formatDate(data.dateOfBirth) : null
        activeStartDate: this.data.activeStartDate ? this.formatDate(this.data.activeStartDate) : null,

        activeEndDate: this.data.activeEndDate ? this.formatDate(this.data.activeEndDate) : null,

        imgLogoUrl: this.data.imgLogoUrl,
        addedBy: this.data.lastupdatedby,
        adminInsurerIds: this.data.insurers,



        // firstName: data.firstName || '',
        // lastName: data.lastName || '',
        // // dateOfBirth: data.dateOfBirth ? this.formatDate(data.dateOfBirth) : null,
        // gender: data.gender || '',
        // email: data.email || '',
        // phone: data.phone || '',
        // address: data.address || '',
        // organisationName: data.organisationName || '',
        // imgLogoUrl: data.imgLogoUrl || '',
        //  role: 'ADMIN_INSURER',
        //  // Static as per form definition
        // //  role: 'ADMIN_DISTRIBUTOR',
        // addedBy: data.createdby || 'SUPER_ADMIN'
      });
      if (data.insurers && Array.isArray(data.insurers)) {
        this.selectedProviderIds = [...data.insurers]; // Clone to avoid mutation
      }
    }
  }

  fileUploaded: any;
  async onAssetImage(event: any) {
    const file = event.files[0];
    console.log(file);
    this.fileUploaded = file;
    this.previewImage(file);
    const url = await this.getfiles3Url(file);
    this.insurerForm.get('imgLogoUrl')?.patchValue(url.documentPath);
  }

  previewImageby(url: any) {
    this.imagePreviewUrl = url;
  }

  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imagePreviewUrl = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  formatDate(dateStr: string): Date | null {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const [day, month, year] = parts.map(Number);
      return new Date(year, month - 1, day);
    }
    return null;
  }

  getfiles3Url(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      this.restService.uploadFile(file).subscribe(
        (response) => resolve(response),
        (error) => reject(error)
      );
    });
  }

  onFileInputClick() {
    console.log("clicked");

  }

  onsubmit() {

    console.log(this.insurerForm.value);
    console.log(this.admindistributorpayload);


       const singlepayload={

        "createdby": "john.smith",
  "firstname": this.insurerForm.get('contactPerson')?.value,
  "lastname": "Smith",   
  "name": "Alex Smith",
  "dateOfBirth": "1990-05-20",
  "gender": "Male",
  "email": "Dany.smith@healthfirsttech.com",
  "phone": "+1334657890",
  "address": "123 Main Street, Anytown, USA",
  "yearsOfExperience": 5,
  "role": "ADMIN_DISTRIBUTOR",
  "activeStartDate": this.insurerForm.get('activeStartDate')?.value ? this.datepipe.transform(this.insurerForm.get('activeStartDate')?.value, 'dd-MM-yyyy')
        : '',
  "activeEndDate": this.insurerForm.get('activeEndDate')?.value ? this.datepipe.transform(this.insurerForm.get('activeEndDate')?.value, 'dd-MM-yyyy')
        : '',
  "orgId": "ORG35D51"
       }


    const payload = {
      fcaReferenceNumber: this.insurerForm.get('fcaReferenceNumber')?.value,
      tradingName: this.insurerForm.get('tradingName')?.value,
      role: 'ADMIN_DISTRIBUTOR',
      address: this.insurerForm.get('address')?.value,
      websitrUrl: this.insurerForm.get('websiteUrl')?.value,
      contactName: this.insurerForm.get('contactPerson')?.value,
      email: this.insurerForm.get('contactEmail')?.value,
      contactPhone: this.insurerForm.get('contactPhone')?.value,

      activeStartDate: this.insurerForm.get('activeStartDate')?.value ? this.datepipe.transform(this.insurerForm.get('activeStartDate')?.value, 'dd-MM-yyyy')
        : '',
      activeEndDate: this.insurerForm.get('activeEndDate')?.value ? this.datepipe.transform(this.insurerForm.get('activeEndDate')?.value, 'dd-MM-yyyy')
        : '',
      imgLogoUrl: this.insurerForm.get('imgLogoUrl')?.value,
      addedBy: this.memberService.getLoginUserId(),
      adminInsurerIds: this.insurerForm?.value?.adminInsurerIds,


      //  InsurerIds:['a7bb9239-ed26-4606-a80a-cc1b97a96f82']
    }


  

    const iseditable = !!this.editedAdmin?.id;
    console.log('the is editable is ' + iseditable);
    // const apicall = iseditable ? this.restService.editAdmins(payload, this.editedAdmin.id) : this.restService.addAdminDisturer(payload)

    console.log(this.insurerForm.get('activeStartDate')?.value)
    
     if (this.insurerForm.valid && this.selectedProviderIds.length > 0 && this.validateDateRange()) {
      this.isSubmitLoading = true;


    const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '350px';
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = false;
      
          const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
          dialogRef.componentInstance.title = 'Confirm';
          dialogRef.componentInstance.mode = iseditable?'edit':'add';
          dialogRef.componentInstance.message = iseditable?'Are You Sure You Want To Edit Agent':'Are You Sure You Want To Add Agent';
          dialogRef.afterClosed().subscribe((res)=>{

            console.log( "the response " + res)
         if(res){

          const apicall = iseditable ? this.restService.editAdmins(payload, this.editedAdmin.id) : this.restService.addAdminDisturer(payload)
    apicall.subscribe({
      next: (value) => {
        if (value) {
          // const apicall = iseditable ? this.restService.editAdmins(payload, this.editedAdmin.id) : this.restService.addAdminDisturer(payload)
          this.notificationService.showNotification(iseditable ? 'admin distributer updated sucessfully' : 'admin distributor added successfully'
          )
          this.dialogRef.close(true);

        }
        console.log(value);
      },
      error: (err) => {
        console.log(err)
        this.notificationService.showNotification(err.error.error)
        this.dialogRef.close(true)
      }
    })} })}







    // if (this.insurerForm.valid && this.selectedProviderIds.length > 0 && this.validateDateRange()) {
    //   this.isSubmitLoading = true;

    //   // Prepare the form data with new fields
    //   const formData = {
    //     ...this.insurerForm.value,
    //     // Map new fields to legacy fields for backward compatibility
    //     firstName: this.insurerForm.get('contactPerson')?.value || '',
    //     lastName: '',
    //     email: this.insurerForm.get('contactEmail')?.value || '',
    //     phone: this.insurerForm.get('contactPhone')?.value || '',
    //     organisationName: this.insurerForm.get('tradingName')?.value || '',
    //     // Add new fields
    //     fcaReferenceNumber: this.insurerForm.get('fcaReferenceNumber')?.value,
    //     tradingName: this.insurerForm.get('tradingName')?.value,
    //     websiteUrl: this.insurerForm.get('websiteUrl')?.value,
    //     contactPerson: this.insurerForm.get('contactPerson')?.value,
    //     contactEmail: this.insurerForm.get('contactEmail')?.value,
    //     contactPhone: this.insurerForm.get('contactPhone')?.value,
    //     activeStartDate: this.insurerForm.get('activeStartDate')?.value,
    //     activeEndDate: this.insurerForm.get('activeEndDate')?.value,
    //     selectedProviderIds: this.selectedProviderIds
    //   };

    //   console.log('Submitting form data:', formData);

    //   // TODO: Implement the actual API call here
    //   // this.restService.addAdminDistributor(formData).subscribe({
    //   //   next: (response) => {
    //   //     this.notificationService.showNotification('Admin Distributor added successfully', 'success');
    //   //     this.dialogRef.close(response);
    //   //   },
    //   //   error: (error) => {
    //   //     this.notificationService.showNotification(error.message || 'Error adding admin distributor', 'error');
    //   //   },
    //   //   complete: () => {
    //   //     this.isSubmitLoading = false;
    //   //   }
    //   // });

    //   // Temporary implementation
    //   setTimeout(() => {
    //     this.isSubmitLoading = false;
    //     this.notificationService.showNotification('Form submitted successfully!', 'success');
    //     this.dialogRef.close(formData);
    //   }, 2000);
    // } else {
    //   // this.notificationService.showNotification('Please fill all required fields and select at least one provider', 'error');
    // }
  }

  closeDialog() {

    this.dialogRef.close();
  }

  insurerForm: FormGroup;
  popupTitle = 'Add Admin Distributor';
  popupSubtitle = 'Please provide the information below to add a new admin Distributor.';
  isSubmitLoading: boolean = false;
  enumConfirmationMode = ConfirmationMode;
  userAccess = this.memberService.getUserAccess();
  enumRole = Roles;
  today = new Date();
  userRole = this.memberService.getLoginUserRole();

  @Input() isDismissable: boolean = false;
  imagePreviewUrl: string | ArrayBuffer | null = null;
  editedAdmin: any;
  admindistributorpayload = {
    "fcaReferenceNumber": "",
    "contactName": "",
    "email": '',
    "contactPhone": "",
    "address": "",
    "tradingName": "",
    "role": "",
    "websitrUrl": "",
    "activeStartDate": "",
    "activeEndDate": "",
    "addedBy": "",
    "imgLogoUrl": "",
    "adminInsurerIds": ""
  }
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<AddMemberComponent>, private dialog: MatDialog,
    private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService, private datepipe: DatePipe,
    private notificationService: NotificationService, @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data) {
      this.editedAdmin = data;
      console.log(this.editedAdmin)
    }

    this.insurerForm = this.fb.group({
      // FCA Reference Number (FRN) - Key Identifier
      fcaReferenceNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],

      // Trading name
      tradingName: ['', Validators.required],

      // Logo (for UI) - already exists as imgLogoUrl
      imgLogoUrl: ['',Validators.required],

      // Address
      address: ['', Validators.required],

      // Website URL
      websiteUrl: ['', [Validators.required, Validators.pattern(/^https?:\/\/.+/)]],

      // Key contact info
      contactPerson: ['', Validators.required],
      contactEmail: ['', [Validators.required, Validators.email]],
      contactPhone: ['', [Validators.required,Validators.pattern(/^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/)]],

      // Active start and end dates
      activeStartDate: ['', Validators.required],
      activeEndDate: [''],

      // Legacy fields (keeping for backward compatibility)
      firstName: ['',],
      lastName: ['',],
      dateOfBirth: [''],
      gender: ['', ],
      email: ['', []],
      phone: ['', []],
      organisationName: [''],
      role: ['ADMIN_INSURER'],
      addedBy: ['SUPER_ADMIN'],
      adminInsurerIds:['',[Validators.required]]
    });

    // Add custom validation for end date
    this.insurerForm.get('activeEndDate')?.valueChanges.subscribe(endDate => {
      const startDate = this.insurerForm.get('activeStartDate')?.value;
      if (endDate && startDate && new Date(endDate) <= new Date(startDate)) {
        this.insurerForm.get('activeEndDate')?.setErrors({ invalidEndDate: true });
      } else {
        this.insurerForm.get('activeEndDate')?.setErrors(null);
      }
    });

  }

  // Method to validate date range
  validateDateRange(): boolean {
    const startDate = this.insurerForm.get('activeStartDate')?.value;
    const endDate = this.insurerForm.get('activeEndDate')?.value;

    if (endDate && startDate) {
      return new Date(endDate) > new Date(startDate);
    }
    return true;
  }

  getAdminInsurer() {
    this.adminInsurerList = [];
    this.restService.getAllAdminInsurers().subscribe({
      next: (values) => {
        this.adminInsurerList = values;
        console.log(values)
      },
      error: (err) => {
        console.log(err);
        this.notificationService.showNotification(err);
      }
    })
  }

  adminInsurerList: any[] = [];

  selectedProviderIds: string[] = [];

  selectProvider(user: any) {
    const index = this.selectedProviderIds.indexOf(user.id);
    if (index > -1) {
      // Already selected → deselect
      this.selectedProviderIds.splice(index, 1);
    } else {
      // Not selected → add
      this.selectedProviderIds.push(user.id);
    }
    this.insurerForm.patchValue({adminInsurerIds:this.selectedProviderIds})
    console.log(this.selectedProviderIds)
  }


}
